import React from 'react';
import { css } from '@emotion/react';

import CarrierOnboarding from './components/CarrierOnboarding';

/**
 * The Accounts page's Onboarding view, the parent for both account kinds: carrier onboarding, or a coming-soon panel
 * for shippers.
 *
 * @param {{ kind: 'carrier'|'shipper', search: string }} props
 */
const OnboardingView = ({ kind, search }) => (
    // The wrapper stays bare: `.onward-design .flex` matches descendants only.
    <div
        className="onward-design"
        css={css`
            display: flex;
            flex: 1;
            min-height: 0;
            width: 100%;
        `}
    >
        <div className="flex min-h-0 w-full flex-1">
            {kind === 'carrier' ? (
                <CarrierOnboarding search={search} />
            ) : (
                <div className="flex w-full items-center justify-center rounded-lg border border-slate-300 bg-white p-10 text-[14px] text-slate-500">
                    Shipper onboarding is coming soon.
                </div>
            )}
        </div>
    </div>
);

export default OnboardingView;
